import {createSelector} from 'reselect'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import {checkRedirectDomain, getRedirectDeepLink} from '@rambler-id/url'

export const selectSnackbar = (state) => state.app.snackbar
export const selectAllowedDomains = (state) => state.app.allowedDomains
export const selectAllowedSchemas = (state) => state.app.allowedSchemas

export const createSelectQuery = (name) =>
  createSelector(
    (state) => state.app.urlQuery,
    (urlQuery) => (urlQuery ? urlQuery[name] : '')
  )

export const selectProject = createSelectQuery('rname')

export const selectRedirectUrl = createSelector(
  (state) => state.app.allowedDomains,
  createSelectQuery('back'),
  (domains, url) => {
    if (!domains) {
      return
    }

    const allowed = checkRedirectDomain(url, domains)

    if (allowed) {
      return url
    }

    if (url && domains) {
      Sentry.captureException(new Error(`Unallowed URL param \`back\`: ${url}`))
    }

    return null
  }
)

export const selectRedirectDeepLink = createSelector(
  selectAllowedSchemas,
  createSelectQuery('redirect_to_scheme'),
  (allowedSchemas, schema) => getRedirectDeepLink(schema, '', allowedSchemas)
)

export const selectVariations = createSelector(
  (state) => state.app.variations,
  (variations) => variations || {}
)
